import React from 'react'
import { connect } from 'react-redux'
import EventsActions from '../../Redux/EventsRedux'
import Select from 'react-select'

class CreateEventsPriority extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedEvent: '',
      form: {
        event_id: '',
        is_popular: true,
        priority: ''
      }
    }
  }

  componentDidMount = () => {
    this._fetchAllEvents()
  }

  _fetchAllEvents = (event) => {
    if (event) {
      event.preventDefault()
    }
    let filter = {
      page: 1,
      limit: 1000
    }
    this.props.getAllEvents(filter)
  }

  _inputChange = (event, field) => {
    let form = { ...this.state.form }
    if (field === 'event_id') {
      form.event_id = event.value
      this.setState({ selectedEvent: event, form })
    } else {
      let value = event.target.value
      form[field] = value
      this.setState({ form })
    }
  }

  _submit = (event) => {
    event.preventDefault()
    let form = { ...this.state.form }
    const data = {
      event_id: this.state.form.event_id,
      form
    }
    this.props.setPriority(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    const { events } = this.props

    // populate event selector
    let eventPicker = []
    events.data.data && events.data.data.length && events.data.data.map((item, i) => {
      eventPicker[i] = {
        value: item.event_id,
        label: item.name
      }
      return eventPicker
    })

    return (
      <div className='section' style={{ width: '40vw' }} >
        <div className='title-block'>
          <h4 className='title mr-auto'>Add Popular Event</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)} >
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Event</label>
            </div>
            <div className='col-9'>
              <Select
                options={eventPicker}
                name='event-picker'
                required
                placeholder='Pick Available Event'
                value={this.state.selectedEvent}
                onChange={(selectedEvent) => this._inputChange(selectedEvent, 'event_id')}
              />
            </div>
          </div>
          <div className='form-group row' >
            <div className='col-3'>
              <label className='control-label'>Set Priority</label>
            </div>
            <div className='col-9'>
              <input
                name='priority-input'
                type='number'
                min='1'
                max='12'
                className='form-control'
                placeholder='Set Priority'
                value={this.state.form.priority}
                onChange={(event) => this._inputChange(event, 'priority')}
              />
            </div>
          </div>
          <div className='form-group text-right'>
            <button type='button' className='btn btn-secondary' onClick={() => this.props.closeModal()}>Cancel</button>
            <button type='submit' className='btn btn-primary ml-2'>Save</button>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  events: state.events
})

const dispatchToProps = (dispatch) => ({
  getAllEvents: (filter) => dispatch(EventsActions.getAllEventsRequest(filter)),
  setPriority: (data) => dispatch(EventsActions.setPopularEventRequest(data))
})

export default connect(stateToProps, dispatchToProps)(CreateEventsPriority)



// WEBPACK FOOTER //
// ./src/Containers/Events/CreateEventsPriority.js